<template>
    <div class="row">
        <FormGroup :label="$t('labels.user_name')" class="col-lg-6">
            <Input v-model="login"/>
        </FormGroup>
        <FormGroup :label="$t('labels.password')" class="col-lg-6">
            <Input v-model="password" type="password"/>
        </FormGroup>
    </div>
</template>
<script>
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';

export default {
    name: "LoginPasswordCredentialFields",
    components: {
        FormGroup, Input
    },
    props: {
        credential: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            login: this.credential?.login ?? '',
            password: this.credential?.password ?? ''
        };
    },
    methods: {
        buildRequest() {
            let request = {
                login: this.login,
                password: this.password
            };

            return request;
        }
    }
}
</script>
